import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M20 4a7.73 7.73 0 0 0-9.7-1L6.9 5.28a1 1 0 0 1-.56.16h-2A4.94 4.94 0 0 0 .83 6.91l-.24.24a2 2 0 0 0 0 2.85l1 1a.93.93 0 0 1 .29.64 3 3 0 0 0 .88 1.94l7.77 7.77a3 3 0 0 0 1.94.88.93.93 0 0 1 .64.29l1 1a2 2 0 0 0 2.83 0l.24-.25a4.94 4.94 0 0 0 1.47-3.53v-2a1 1 0 0 1 .16-.56L21 13.7A7.73 7.73 0 0 0 20 4m-4.21 13.4-2.48 2.48a1 1 0 0 1-1.41 0L4.12 12.1a1 1 0 0 1-.29-.71 1 1 0 0 1 .29-.7l2.47-2.48A.54.54 0 0 1 7 8.07a.5.5 0 0 1 .35.14l8.49 8.49a.51.51 0 0 1 0 .7Zm1.41-7.07a2.5 2.5 0 1 1 0-3.53 2.49 2.49 0 0 1 0 3.53M2.75 2.5a.25.25 0 0 1 .25.25.75.75 0 0 0 1.5 0 .25.25 0 0 1 .25-.25.75.75 0 0 0 0-1.5.25.25 0 0 1-.25-.25.75.75 0 0 0-1.5 0 .25.25 0 0 1-.25.25.75.75 0 0 0 0 1.5m3 19a.25.25 0 0 1-.25-.25.75.75 0 0 0-1.5 0 .25.25 0 0 1-.25.25.75.75 0 0 0 0 1.5.25.25 0 0 1 .25.25.75.75 0 0 0 1.5 0 .25.25 0 0 1 .25-.25.75.75 0 0 0 0-1.5m17.5-5a.25.25 0 0 1-.25-.25.75.75 0 0 0-1.5 0 .25.25 0 0 1-.25.25.75.75 0 0 0 0 1.5.25.25 0 0 1 .25.25.75.75 0 0 0 1.5 0 .25.25 0 0 1 .25-.25.75.75 0 0 0 0-1.5m-20.75.75a.75.75 0 1 0 1.5 0 .75.75 0 1 0-1.5 0m6-15.5a.75.75 0 1 0 1.5 0 .75.75 0 1 0-1.5 0m13 20a.75.75 0 1 0 1.5 0 .75.75 0 1 0-1.5 0"
    }, null, -1)
  ]));
}
const interfaceShareSpaceShip = { render };
export {
  interfaceShareSpaceShip as default,
  render
};
//# sourceMappingURL=interface-share-space-ship.svg.js.map
